<template>
  <div class="search-bar-mobile"  role="search">
    <div id="backdrop" class="fade in modal-backdrop" @click="$emit('on-close-modal')"></div>
    <div id="modalDetailService" data-once="modal" role="dialog" aria-modal="true" class="collapsetomodal staticmodal"
      :aria-labelledby="ariaLabelledby">
      <div id="firstfocusmodal" class="firstfocusmodal" tabindex="0" ref="firstFocusModal"></div>
      <div class="modal-dialog">
        <div class="modal-content hero-banner-search">
          <div class="modal-header">
            <div class="modal-header_list-btn">
              <button type="button" @click="onCloseModal"
                class="btn-close modal-header_list-btn_btn-position" aria-label="Fermer">
                <i class="icon-cross-out" aria-hidden="true"></i>
                <span style="font-size: 20px;"> Annuler </span>
              </button>
              <button class="btn-search" :disabled="searchText?.length < 2"
                @click="$emit('onSearch', { searchText, locationText })">
                <i class="icon-search" aria-hidden="true"></i>
                <span class="sr-only-desktop">Rechercher</span>
              </button>
            </div>

            <div>
              <input type="text" v-model="searchText" @focus="searchInput()" @keyup="searchInput()"
                @focusout="focusOutInput()" class="input-what" :placeholder="searchPlaceholderTitle" :title="searchPlaceholderTitle" ref="inputWhatMob" />
              <input type="text" v-model="locationText" @focus="locationInput()" @keyup="locationInput()"
                @focusout="focusOutLocationInput()" class="input-where" :placeholder="searchPlaceholderWhere" :title="searchPlaceholderWhere" />
            </div>

          </div>
          <div class="modal-body" style="padding-left: 0px !important;padding-right: 0px !important;">
            <WhatAutoComplete :displayListSearch="displayListSearch" :searchListHistoyFiltred="searchListHistoyFiltred"
              :HistoryHasSearch="searchText.length >= 3"
              :searchText="searchText"
              :searchListApi="searchListApi" @onRemoveSearchItem="$emit('onRemoveSearchItem', $event)"
              @onClearSearchHistory="$emit('onClearSearchHistory')" @onClickSearchText="searchText = $event" />
            <WhereAutoComplete :displayListLocations="displayListLocations" :locationListApi="locationListApi"
              :locationListHistoyFiltred="locationListHistoyFiltred"
              @onClearLocationHistory="$emit('onClearLocationHistory')"
              @onRemoveLocationItem="$emit('onRemoveLocationItem', $event)"
              @onClickLocationText="locationText = $event" />
          </div>
        </div>
      </div>
      <div ref="lastFocusModal" class="lastfocusmodal" tabindex="0"></div>
    </div>
  </div>
</template>

<script>

import {
  computed, inject, ref, watch, nextTick,
} from 'vue';
import WhatAutoComplete from '@/components/homePage/autoCompleteComponents/WhatAutoComplete.component.vue';
import WhereAutoComplete from '@/components/homePage/autoCompleteComponents/WhereAutoComplete.component.vue';
import { debounce, htmlStripper } from '@/helpers';

export default {
  components: {
    WhatAutoComplete,
    WhereAutoComplete,
  },
  emits: [
    'onSearch',
    'onClearSearchHistory',
    'onRemoveSearchItem',
    'onClearLocationHistory',
    'onRemoveLocationItem',
    'onSearchinput',
    'onLocationinput',
  ],
  props: {
    ariaLabelledby: {
      type: String,
      default: 'titlemodale',
    },
    isCollapsetoModal: {
      type: Boolean,
      default: false,
    },
    searchListHistory: {
      type: Array,
      default: () => [],
    },
    searchListApi: {
      type: Array,
      default: () => [],
    },
    locationListHistory: {
      type: Array,
      default: () => [],
    },
    locationListApi: {
      type: Array,
      default: () => [],
    },
  },
  setup(props, { emit }) {
    const displayListSearch = ref(false);
    const what = inject('what');
    const where = inject('where');
    const searchText = ref(what);
    const firstFocusModal = ref(null);
    const lastFocusModal = ref(null);
    const searchListHistoyFiltred = computed(() => (searchText.value.length <= 2 ? props.searchListHistory
      : props.searchListHistory.filter((elem) => elem.indexOf(searchText.value) === 0)));
    const searchInput = debounce(() => {
      emit('onSearchinput', encodeURIComponent(searchText.value));
      displayListSearch.value = true;
    });
    const focusOutInput = debounce(() => { displayListSearch.value = false; });

    const searchPlaceholders = inject('searchPlaceholders');
    const searchPlaceholderTitle = searchPlaceholders.text_mobile;
    const searchPlaceholderWhere = searchPlaceholders.text_where;

    const displayListLocations = ref(false);
    const locationText = ref(where);
    const locationListHistoyFiltred = computed(() => (locationText.value.length <= 2 ? props.locationListHistory : []));
    const locationInput = debounce(() => {
      emit('onLocationinput', locationText.value.length > 2 ? locationText.value : null);
      displayListLocations.value = true;
    });
    const focusOutLocationInput = debounce(() => { displayListLocations.value = false; });
    const isScreenMdMin = inject('isScreenMdMin');
    const isHeaderMode = inject('isHeaderMode');
    const isLessThanLargeDesktop = inject('isLessThanLargeDesktop');
    const inputWhatMob = ref(null);

    function onCloseModal() {
      emit('on-close-modal');
    }

    watch(() => props.isActive, () => {
      if (props.isActive) {
        nextTick(() => {
          firstFocusModal.value.focus();
        });
      }
    });

    document.body.addEventListener('keydown', (e) => {
      if (e.code === 'Escape') {
        emit('on-close-modal');
      }

      if (e.code === 'Tab') {
        if (document.activeElement === lastFocusModal.value) {
          firstFocusModal.value.focus();
        }
      }

      if (e.shiftKey && e.code === 'Tab') {
        if (document.activeElement === firstFocusModal.value) {
          lastFocusModal.value.focus();
        }
      }
    });

    return {
      displayListSearch,
      searchText,
      searchListHistoyFiltred,
      searchPlaceholderTitle,
      searchPlaceholderWhere,
      debounce,
      searchInput,
      focusOutInput,
      htmlStripper,
      locationText,
      displayListLocations,
      locationListHistoyFiltred,
      locationInput,
      focusOutLocationInput,
      isScreenMdMin,
      isHeaderMode,
      isLessThanLargeDesktop,
      inputWhatMob,
      onCloseModal,
      firstFocusModal,
      lastFocusModal,
    };
  },
};
</script>
<style lang="scss">
.search-bar-mobile {
  .modal-header {
    &_list-btn {
      display: flex;
      padding: 20px;
      padding-right: 0px;

      &_btn-position {
        position: relative !important;
        display: flex;
        align-items: center;

        i {
          margin-right: 10px;
        }
      }

      .btn-search {
        padding-left: inherit;
        width: 40%;
        border-radius: inherit;
        margin-top: inherit;
        flex: 1;

        i {
          margin-right: 10px;
        }
      }
    }
  }

  .hero-banner-search {
    padding: inherit;

    .modal-header {
      background: #5677b0;
    }
  }
  .modal-body {
    .short-search-wrapper {
      position: relative;
      width: 100%;
      box-shadow: none;
      top: 0px !important;
      left: 0px !important;
    }
  }
}
</style>
